import { call, takeEvery } from 'redux-saga/effects';
import { SET_REVIEWER_RESULT, ADD_MEETING_ARRANGEMENT_REVIEWER_RESULT, GET_TYPEOFREVIEW } from 'store/key';
import { produce } from 'utility/general';
import { setGlobalLoading } from 'store/global/reducer';
import API from 'api/call';
import { safeSaga } from 'store';

const initialState = {};

function* addMeetingReviewerResult(action) {
    const { data, callback } = action.payload;
    setGlobalLoading(true);
    try {
        yield call(API.confirmResult.addMeetingReviewerResult, { ...data });

        callback?.();
    } catch (error) {
        console.log('create reviewer failed:', error);
    }
    setGlobalLoading(false);
}

function* getTypeOfReview(action) {
    const { params, callback } = action.payload;
    setGlobalLoading(true);
    try {
        const result = yield call(API.confirmResult.getTypeOfReview, { params });
        const res = result.data.result;
        callback?.(res);
    } catch (error) {
        console.log('create reviewer failed:', error);
    }
    setGlobalLoading(false);
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_REVIEWER_RESULT:
            const newState = produce(state, (draft) => {
                Object.entries(action.payload).forEach(([key, value]) => {
                    draft[key] = action.payload[key];
                });
            });
            return newState;
        default:
            return state;
    }
};
export function* watchConfirmResult() {
    yield takeEvery(ADD_MEETING_ARRANGEMENT_REVIEWER_RESULT, safeSaga(addMeetingReviewerResult));
    yield takeEvery(GET_TYPEOFREVIEW, safeSaga(getTypeOfReview));
}

export default reducer;
